import React from 'react';
import { Box, Chip, Container, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material';
import { UniformRequest, UniformRequestStatus } from '../../../types/UniformRequest';
import { RunCircleRounded, MopedRounded, CheckCircleRounded, CancelRounded, FiberNewRounded } from '@mui/icons-material';
import { ChipIcon, ChipColor } from '../passport/PassportRequestsPage';
import { DateTime } from 'luxon';

const getIconFromStatus = (status: UniformRequestStatus) => {
  if (status === 'Processing') return <RunCircleRounded />;
  else if (status === 'Available') return <MopedRounded />;
  else if (status === 'Completed') return <CheckCircleRounded />;
  else if (status === 'Cancelled') return <CancelRounded />;
  return <FiberNewRounded />;
};

const getColorFromStatus = (status: UniformRequestStatus) => {
  if (status === 'Processing') return 'warning';
  else if (status === 'Available') return 'secondary';
  else if (status === 'Completed') return 'success';
  else if (status === 'Cancelled') return 'error';
  return 'info';
};

type Props = {
  uniformRequest: UniformRequest;
};
export const UniformRequestInfoBox = (props: Props) => {
  const { uniformRequest } = props;

  return (
    <Container disableGutters>
      <Box>
        <TableContainer>
          <Table size="small">
            <TableBody>
              <TableRow>
                <TableCell width={250}>Id Number</TableCell>
                <TableCell>{uniformRequest.idNumber}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Name</TableCell>
                <TableCell>{uniformRequest.name}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Date Requested</TableCell>
                <TableCell>{DateTime.fromISO(uniformRequest.dateRequested).toFormat('MMMM dd, yyyy — hh:mm:ss a')}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Type</TableCell>
                <TableCell>{uniformRequest.type}</TableCell>
              </TableRow>
              <TableRow>
                <TableCell width={250}>Date Completed</TableCell>
                <TableCell>{uniformRequest.dateCompleted ? DateTime.fromISO(uniformRequest.dateCompleted).toFormat('MMMM dd, yyyy — hh:mm:ss a') : ''}</TableCell>
              </TableRow>
              <TableRow sx={{
                '&:last-child td, &:last-child th': { border: 0 } 
              }}>
                <TableCell width={250}>Status</TableCell>
                <TableCell>
                  <Chip 
                    icon={getIconFromStatus(uniformRequest.status)} 
                    label={uniformRequest.status} 
                    color={getColorFromStatus(uniformRequest.status)}
                    variant="outlined" />
                  </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
      </Box>
    </Container>
  );
};
